import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { CircleBone, FrameBone, ParagraphBone } from '@gik/ui';
import repeatElement from '@gik/core/utils/repeatElement';
import { useRandomInt } from '@gik/core/utils/getRandomInt';

const blockName = 'user-pages-list-skeleton';

export default function UserPagesListSkeleton() {
  const bem = bemBlock(blockName);

  return (
    <ul className={bem()}>
      {repeatElement(
        3,
        <li>
          <FrameBone className={bemBlock('user-page-card')()}>
            <CircleBone />
            {repeatElement(2, <ParagraphBone words={useRandomInt(2, 5)} />)}
          </FrameBone>
        </li>
      )}
    </ul>
  );
}
